export const getCategoryOptions = (store) => {
  const categories = store.category.categories;

  return categories.map((item) => ({ value: item._id, label: item.title }));
};
